<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            values: values.$ | async,
            massSelectionState: massSrv.essentialSubscriptions$ | async,
        } as data"
    >
        <div
            [class]="'bazis-control bazis-control_autocomplete ' + cssClassSizeControl"
            [ngClass]="{
                'bazis-control--activated': showList,
                'bazis-control--dirty': ngControl.control.dirty,
                'bazis-control--empty': !ngControl.control.value?.length,
                'bazis-control--invalid': ngControl.control.invalid,
                'bazis-control--disabled': isDisabled,
            }"
        >
            <bazis-toolbar class="bh-margin-bottom-1x">
                <bazis-label
                    slot="start"
                    [isMajor]="hasTitleMajor"
                    [isEmptyLabel]="isEmptyLabel"
                    [title]="title || t(titleKey, titleParams)"
                    [required]="data.required"
                    class="bh-no-margin"
                >
                    <bazis-interrogation
                        *ngIf="tooltipKey"
                        [slot]="tooltipSettings?.targetSide"
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="[-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                    ></bazis-interrogation>
                </bazis-label>

                @if (ngControl.control.value?.length) {
                    <div
                        slot="end"
                        class="bh-align-items-center"
                    >
                        <span class="bazis-text_secondary">{{ t('title.selected') }}: </span>
                        <span class="bh-padding-horizontal-1x">{{
                            ngControl.control.value.length
                        }}</span>
                        <bazis-icon
                            name="cross"
                            size="compact"
                            class="bazis-text_secondary bh-pointer"
                            (click)="onClear()"
                        ></bazis-icon>
                    </div>
                }
            </bazis-toolbar>

            <div
                *ngIf="viewTypeSelected === 'tagsStart'"
                class="bazis-tags-group"
            >
                <ng-container [ngTemplateOutlet]="tplTags"></ng-container>
            </div>

            <div
                #wrapper
                class="bazis-list_control-dd-wrapper"
                [class.bh-events-none]="isDisabled"
                clickOutside
                (clickOutside)="hideList()"
            >
                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="isDisabled"
                >
                    <bazis-control-field-start
                        [isClickable]="isLeftIconClickable"
                        [icon]="leftIcon"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        (actionClick)="onLeftIconClick($event)"
                    >
                    </bazis-control-field-start>

                    <div
                        class="bazis-control__field"
                        [class.bazis-control__field--focused]="
                            isFocused || (showList && searchControl.value)
                        "
                    >
                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            [class.bazis-select_secondary]="type === 'secondary'"
                            (click)="toggleList()"
                        >
                            <div
                                *ngIf="viewTypeSelected === 'inside'"
                                class="bazis-select__trigger"
                            >
                                <span>
                                    <ng-container
                                        [ngTemplateOutlet]="tplSelectTrigger"
                                    ></ng-container>
                                </span>
                            </div>
                            <input
                                #searchInput
                                class="bazis-control__field"
                                [class.bazis-control__field--focused]="
                                    isFocused || (showList && searchControl.value)
                                "
                                [class.bazis-control__field_opacity]="!searchControl.value"
                                [formControl]="searchControl"
                                [mask]="maskSettings?.mask"
                                [patterns]="maskSettings?.patterns"
                                (focus)="focusField()"
                                (blur)="isFocused = false"
                                [placeholder]="
                                    ngControl.control.value.length
                                        ? placeholderKeyValue
                                            ? t(placeholderKeyValue)
                                            : placeholderKey
                                              ? t(placeholderKey)
                                              : ''
                                        : placeholderKey
                                          ? t(placeholderKey)
                                          : ''
                                "
                            />
                        </div>
                    </div>

                    <bazis-control-search-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [hasSearchIcon]="hasSearchIcon"
                        [multiple]="multiple"
                        [isDisabled]="isDisabled"
                        [canEraserShow]="
                            hasEraser &&
                            (viewTypeSelected === 'inside' || viewTypeSelected === 'empty')
                        "
                        [searchValue]="searchControl.value"
                        [controlValue]="ngControl.control.value"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [otherIcon]="rightIcon"
                        [showList]="showList"
                        (erased)="onClear()"
                        (toggled)="toggleList()"
                        (hideListMobile)="hideListMobile()"
                    ></bazis-control-search-end>
                </div>

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                    <ng-content select="error"></ng-content>
                </div>

                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ t(noteKey) }}
                </div>

                <ng-content select="note"></ng-content>

                @if (!loadListOnClick || showList) {
                    <div
                        #listHint
                        class="bh-popper-z-index"
                        [hidden]="!showList"
                        (click)="clickPopper()"
                    >
                        <app-multiple-selection-infinite-list
                            [searchSettings]="searchSettings"
                            [emptyValue]="emptyValueEntity"
                            [staticOptionsEntities]="staticOptionsEntities"
                            [excludeIds$]="excludeIds$"
                            [emptyListKey]="emptyListKey || 'title.emptySearch'"
                            [search$]="searchValue$"
                            [infiniteListTpl]="infiniteListTpl"
                            [valuesMap]="valuesMap"
                            (toggled)="toggleValue($event)"
                        >
                        </app-multiple-selection-infinite-list>
                    </div>
                }
            </div>

            <div
                *ngIf="viewTypeSelected === 'tagsEnd'"
                class="bazis-tags-group"
                [class.bh-margin-top-2x]="data.values.length"
            >
                <ng-container [ngTemplateOutlet]="tplTags"></ng-container>
            </div>
        </div>

        <ng-template #tplSelectTrigger>
            <ng-container *ngFor="let value of values.$ | async; let i = index">
                <ng-container *ngIf="!value">{{
                    placeholderKey ? t(placeholderKey) : ''
                }}</ng-container>
                <ng-container
                    *ngIf="searchSettings.entityType !== 'organization.organization_info'"
                >
                    <ng-container *ngIf="value | entity: entityType | async as entity">
                        <bazis-autocomplete-selected-value
                            [infiniteListTpl]="infiniteListTpl"
                            [selectedValueTpl]="selectedValueTpl"
                            [entity]="entity"
                            [valuesLength]="values._.length"
                            [index]="i"
                        ></bazis-autocomplete-selected-value>
                    </ng-container>
                </ng-container>
                <ng-container
                    *ngIf="searchSettings.entityType === 'organization.organization_info'"
                >
                    <ng-container *ngIf="value | organization | async as entity">
                        <bazis-autocomplete-selected-value
                            [infiniteListTpl]="infiniteListTpl"
                            [selectedValueTpl]="selectedValueTpl"
                            [entity]="entity"
                            [valuesLength]="values._.length"
                            [index]="i"
                        ></bazis-autocomplete-selected-value>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-template>

        <ng-template #tplTags>
            @for (value of data.values; track value; let i = $index) {
                @if (i < displayCount) {
                    @let entity = value | entity: entityType | async;
                    @if (entity) {
                        <div class="bazis-tag">
                            <span>
                                @if (infiniteListTpl) {
                                    <ng-container
                                        [ngTemplateOutlet]="infiniteListTpl"
                                        [ngTemplateOutletContext]="{ item: entity }"
                                    ></ng-container>
                                } @else {
                                    {{ entity.$snapshot?.name }}
                                }
                            </span>
                            @if (!isDisabled) {
                                <button (click)="toggleValue(value)">
                                    <bazis-icon
                                        [name]="icons.trash"
                                        size="mini"
                                    ></bazis-icon>
                                </button>
                            }
                        </div>
                    }
                }
            }
            @if (data.values.length > displayCount) {
                <div
                    class="bazis-tag bh-pointer"
                    (click)="toggleList()"
                >
                    <span>+ {{ data.values.length - displayCount }}</span>
                    <button (click)="toggleValues($event)">
                        <bazis-icon
                            [name]="icons.trash"
                            size="mini"
                        ></bazis-icon>
                    </button>
                </div>
            }
        </ng-template>
    </ng-container>
</ng-container>
